import { RootState } from 'types';

export const selectPageLoader = (state: RootState) =>
  state?.managePage?.pageLoader;

export const selectIsAccessToken = (state: RootState) =>
  state?.managePage?.isAccessToken;
